export const REGIONS = [
    "Минская",
    "Брестская",
    "Витебская",
    "Гомельская",
    "Гродненская",
    "Могилевская"
];

export const ROLES = [
    { value: 'USER', label: 'Обычный пользователь' },
    { value: 'USER_ORG', label: 'Пользователь организации' },
    { value: 'SETTING_ORG', label: 'Наладчик' },
    { value: 'ADMIN_VODOKANAL', label: 'Администратор водоканала' },
    { value: 'ADMIN_ORG', label: 'Администратор организации' },
    { value: 'ADMIN_SERVER', label: 'Администратор сервера' },
    { value: 'ADMIN_CHIRPSTACK', label: 'Администратор Chirpstack' }
];

export const typeChanel = ["Одноканальный", "Двухканальный"]

export const typeIoT = ["SML-1", "SML-5", "SML-N2", "BB-07K7", "TB-07K7", "CC101", "CC301"]

export const brandIoT = ["LoRa", "NB-IoT", "WMBUS"]

export const typeDevice = [
    { key: "ВС", label: "Счётчик воды" },
    { key: "ТС", label: "Счётчик теплоэнергии" },
    { key: "ЭС", label: "Счётчик электроэнергии" },
];

export const typeResourse = ['Холодная вода', 'Горячая вода', 'Теплоэнергия', 'Электроэнергия']

export const typeOwner = ['Физическое лицо', 'Юридическое лицо'];


export const MONTHS = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
];